import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiStar } from 'react-icons/fi';
import {
  GOOGLE_MAPS_REVIEWS_URL,
  GOOGLE_MAPS_RATING,
  GOOGLE_MAPS_REVIEW_COUNT,
  GOOGLE_REVIEW_KEYS,
} from '../config/googleReviews';
import './Testimonials.css';

function StarRating({ rating, label }) {
  return (
    <div className="testimonials-stars" role="img" aria-label={label}>
      {Array.from({ length: 5 }, (_, index) => (
        <FiStar
          key={index}
          aria-hidden
          className={index < rating ? 'testimonials-star testimonials-star--filled' : 'testimonials-star'}
        />
      ))}
    </div>
  );
}

function Testimonials() {
  const { t } = useTranslation();
  const starsLabel = t('testimonials.starsAria', { rating: GOOGLE_MAPS_RATING });

  return (
    <section id="avis" className="testimonials section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('testimonials.title')}</h2>
          <p className="section-quick-answer">{t('testimonials.quickAnswer')}</p>
        </div>

        <div className="testimonials-summary">
          <div className="testimonials-summary-rating">
            <span className="testimonials-summary-score">{GOOGLE_MAPS_RATING.toFixed(1)}</span>
            <StarRating rating={Math.round(GOOGLE_MAPS_RATING)} label={starsLabel} />
          </div>
          <p className="testimonials-summary-meta">
            {t('testimonials.reviewCount', { count: GOOGLE_MAPS_REVIEW_COUNT })}
          </p>
          <p className="testimonials-summary-source">{t('testimonials.source')}</p>
        </div>

        <div className="testimonials-grid">
          {GOOGLE_REVIEW_KEYS.map((review) => (
            <article key={review.key} className="testimonials-card">
              <StarRating
                rating={review.rating}
                label={t('testimonials.starsAria', { rating: review.rating })}
              />
              <blockquote className="testimonials-quote">
                <p>{t(`testimonials.${review.key}.quote`)}</p>
              </blockquote>
              <footer className="testimonials-author">
                <cite className="testimonials-author-name">{t(`testimonials.${review.key}.author`)}</cite>
                <span className="testimonials-author-meta">{t(`testimonials.${review.key}.meta`)}</span>
              </footer>
            </article>
          ))}
        </div>

        <p className="testimonials-cta">
          <a href={GOOGLE_MAPS_REVIEWS_URL} target="_blank" rel="noopener noreferrer">
            {t('testimonials.viewAll')}
          </a>
        </p>
      </div>
    </section>
  );
}

export default Testimonials;
